import { Endpoints } from 'UI/constants/endpoints';

import { JSON_SCHEMA_CLIENT } from './API';

/**
 * @param {string} schemaName
 */
export const getJsonSchema = async schemaName => {
  return JSON_SCHEMA_CLIENT.get(`${Endpoints.JSONSchema.replace(':schemaName', schemaName)}`);
};
